module.exports = __webpack_public_path__ + "media/stylesheets/images/temp_wolf_planent_kit/card_kit_1-53c88bac29c2b2248f3b8ebb4d3109cf.png";